module.exports = __webpack_public_path__ + "static/media/driverPlusChart.55292c34.svg";